var _a;
import { UnitSuffix } from '../../defs';
import { MILLIMETER_PIXEL_VALUE } from '../../internal/constants';
import { noConvert } from '../../internal/converters';
import { pixel } from '../../internal/converters/pixel';
var millimeterToPixel = function (value) {
    return value * MILLIMETER_PIXEL_VALUE;
};
var millimeterToCentimeter = function (value) {
    return pixel.cm(millimeterToPixel(value));
};
var millimeterToQuarter = function (value) {
    return pixel.Q(millimeterToPixel(value));
};
var millimeterToInch = function (value) {
    return pixel.in(millimeterToPixel(value));
};
var millimeterToPica = function (value) {
    return pixel.pc(millimeterToPixel(value));
};
var millimeterToPoint = function (value) {
    return pixel.pt(millimeterToPixel(value));
};
var millimeterToREM = function (value, options) {
    return pixel.rem(millimeterToPixel(value), options);
};
var millimeterToEM = function (value, options) {
    return pixel.em(millimeterToPixel(value), options);
};
var millimeterToViewWidth = function (value, options) {
    return pixel.vw(millimeterToPixel(value), options);
};
var millimeterToViewHeight = function (value, options) {
    return pixel.vh(millimeterToPixel(value), options);
};
var millimeterToViewMin = function (value, options) {
    return pixel.vmin(millimeterToPixel(value), options);
};
var millimeterToViewMax = function (value, options) {
    return pixel.vmax(millimeterToPixel(value), options);
};
export var millimeter = (_a = {},
    _a[UnitSuffix.Pixel] = millimeterToPixel,
    _a[UnitSuffix.Centimeter] = millimeterToCentimeter,
    _a[UnitSuffix.Millimeter] = noConvert,
    _a[UnitSuffix.Quarter] = millimeterToQuarter,
    _a[UnitSuffix.Inch] = millimeterToInch,
    _a[UnitSuffix.Pica] = millimeterToPica,
    _a[UnitSuffix.Point] = millimeterToPoint,
    _a[UnitSuffix.REM] = millimeterToREM,
    _a[UnitSuffix.EM] = millimeterToEM,
    _a[UnitSuffix.ViewWidth] = millimeterToViewWidth,
    _a[UnitSuffix.ViewHeight] = millimeterToViewHeight,
    _a[UnitSuffix.ViewMin] = millimeterToViewMin,
    _a[UnitSuffix.ViewMax] = millimeterToViewMax,
    _a);
//# sourceMappingURL=millimeter.js.map